import { csrf_headers, get_token } from '@/router/index.js';
import { SYSTEM_MANAGEMENT_ENDPOINTS, build_system_management_url } from '@/constants/system_management_endpoints.js';

const PLATFORM_ALIASES = Object.freeze({
  __proto__: null,
  'x-verdict': ['x-verdict', 'x verdict', 'xverdict'],
  orcaa: ['orcaa', 'orcaa.ai'],
  proba: ['proba', 'proba analytics'],
  engagenet: ['engagenet', 'engage net', 'ic workbook'],
  workflow: ['workflow', 'workflows', 'proba workflows', 'proba-workflows'],
  complyon: ['complyon', 'comply on'],
});

export const PLAYGROUND_PLATFORM_KEYS = Object.freeze(['orcaa', 'proba', 'engagenet']);

export const WORKSPACE_PLATFORM_KEYS = Object.freeze({
  __proto__: null,
  'Learner Content': 'orcaa',
  Assessments: 'orcaa',
  Courses: 'orcaa',
  Programme: 'orcaa',
  File: 'proba',
  Dashboard: 'proba',
  Analysis: 'proba',
  Events: 'engagenet',
  Community: 'engagenet',
  Design: 'workflow',
  Onboarding: 'workflow',
  Signing: 'workflow',
  Project: 'workflow',
  Verification: 'complyon',
  Company: 'complyon',
  'Case Intake': 'x-verdict',
  'Credit Help': 'x-verdict',
  Case: 'x-verdict',
});

function safe_lookup(obj, key) {
  const desc = Object.getOwnPropertyDescriptor(obj, key);
  return (desc && desc.enumerable) ? desc.value : undefined;
}

export function playground_platform_id(key) {
  const names = safe_lookup(PLATFORM_ALIASES, key) || [key];

  try {
    const platforms = JSON.parse(localStorage.getItem('playground_platforms') || '[]');
    const platform = Array.isArray(platforms)
      ? platforms.find((item) => names.includes(String(item?.name || '').trim().toLowerCase()))
      : null;
    return platform?.id || null;
  } catch {
    return null;
  }
}

export async function prepare_playground_platform_launch(platform_key, notyf, router) {
  if (localStorage.getItem('is_playground_user') !== '1') {
    return true;
  }

  const context_id = localStorage.getItem('playground_context_id');
  const platform_id = playground_platform_id(platform_key);

  if (!context_id || !platform_id) {
    notyf?.error?.('Playground context is not ready yet');
    return false;
  }

  try {
    const token = get_token();
    const response = await fetch(
      build_system_management_url(SYSTEM_MANAGEMENT_ENDPOINTS.prepare_playground_platform_session),
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Token ${token}` } : {}),
          ...csrf_headers(),
        },
        body: JSON.stringify({ context_id, platform_id }),
      },
    );
    const body = await response.json();

    if (response.status === 409 || body.status === 'expired') {
      notyf?.error?.(body.message || 'Your Playground session has expired');
      router?.push?.({ name: 'Login' });
      return false;
    }

    if (!response.ok || body.status !== 'success') {
      notyf?.error?.(body.message || 'Unable to prepare this platform');
      return false;
    }

    const redirect_url = body.data?.redirect_url;
    if (redirect_url) {
      window.location = redirect_url;
      return false;
    }

    return true;
  } catch {
    notyf?.error?.('Unable to prepare this platform');
    return false;
  }
}
